export default "__VITE_ASSET__DPnDK1fd__"